<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized && !hasData" class="ml-2 mt-1 mb-1">
  Data unavailable
</div>
<div [hidden]="!initialized || !hasData" class="chart-container">
  <div id="intensityRPEChart"></div>
</div>

